import {useState, useEffect, useCallback, useRef} from '@wordpress/element';
import {isEmail} from '@wordpress/url';
import {useCreateFastlane, useProcessFastlane} from "./hooks";
import {FastlaneModal} from '../../components';
import {useDeviceData} from "../hooks";
import {usePaymentMethodDataContext} from "../context";
import {getClientToken} from "../utils";

export default function ExpressPaymentComponent({getData, ...props}) {
    const {
        billing,
        shippingData,
        setExpressPaymentError
    } = props;

    const {
        billingAddress
    } = billing;

    const {
        email
    } = billingAddress;

    const authOnLoad = getData('fastlane_pageload');

    const isInitialRender = useRef(true);
    const [openModal, setOpenModal] = useState(false);
    const resolveRef = useRef(null);
    const promiseRef = useRef(null);

    const {
        fraud
    } = usePaymentMethodDataContext();

    const dataCollector = useDeviceData({skip: true});

    const openFastlaneModal = useCallback(() => {
        promiseRef.current = new Promise(resolve => {
            resolveRef.current = resolve;
        });
        setOpenModal(true);
        return promiseRef.current;
    }, []);

    const onClose = useCallback((skip = false) => {
        setOpenModal(false);
        if (!skip) {
            resolveRef.current(null);
        }
    }, []);

    const onTokenize = useCallback((data) => {
        resolveRef.current(data);
    }, []);

    const fastlane = useCreateFastlane({
        clientToken: getClientToken(),
        fraudEnabled: fraud.enabled,
        dataCollector
    });

    const {
        onClick,
        processing,
        triggerAuthentication
    } = useProcessFastlane({
        i18n: getData('i18n'),
        email,
        onError: setExpressPaymentError,
        fastlane,
        shippingData,
        openFastlaneModal
    });

    useEffect(() => {
        if (!fastlane || !triggerAuthentication || !isEmail(email)) {
            return;
        }
        // Only trigger on first load if fastlane_pageload is true
        if (authOnLoad && isInitialRender.current) {
            isInitialRender.current = false;
            triggerAuthentication(email, false);
            return;
        }
    }, [email, fastlane, triggerAuthentication]);


    return (
        <>
            <button
                id="wc-ppcp-fastlane-checkout"
                className="wc-ppcp-fastlane-button"
                disabled={openModal || processing}
                onClick={onClick}>
                <img className={'wc-ppcp-fastlane-icon'} src={getData('icon_url')}/>
            </button>
            <FastlaneModal
                i18n={getData('i18n')}
                open={openModal}
                onClose={onClose}
                fastlane={fastlane}
                onTokenize={onTokenize}
                shippingData={shippingData}/>
        </>
    );
}